// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTextButton-Container_cls1__IcyoL","cls2":"VeloTextButton-Container_cls2__frj4S VeloTextButton-Container_cls1__IcyoL","inline":"VeloTextButton-Container_inline__eM1YJ"};